<template>
  <div>
    <table-cadu
      custom
      class="pa-0 ma-0 areamodal"
      :elementsPerPageProp="elementos"
      v-model="selected"
      :showFiltro="false"
      :showCheck="showCheckModalArea"
      :items="['05', '10', '15']"
      :rowsHeader="rowsHeader"
      :rows="rows"
      :pagina="pagina"
      :editar="nomeAcao === 'ADICIONAR' || nomeAcao === 'EDITAR'"
      :qtPaginas="qtPaginas"
      :qtResultados="qtResultados"
      :texto="nomeAcao === 'VISUALIZAR' ? '' : '+ adicionar colaborador'"
      :role="role"
      :ordemProp="ordemProp"
      nameTab="modalArea"
      @change-element="(element) => changeElement(element)"
      @change-page="(currentPage) => $emit('change-page', currentPage)"
      @ordena="(ordem) => ordenaTable(ordem)"
      @clickButton="(obj) => $emit('clickButton', obj)"
    />
  </div>
</template>

<script>
export default {
  props: {
    ordemProp: {
      type: String,
      required: true,
    },
    edit: {
      type: Boolean,
      required: false,
      default: false
    },
    isNew: {
      type: Boolean,
      required: false,
      default: false
    },
    colaboradores: {
      type: Array,
      required: false
    },
    pagina: {
      type: Number,
      required: false
    },
    qtPaginas: {
      type: Number,
      required: false
    },
    qtResultados: {
      type: Number,
      required: false
    },
    showCheckModalArea: {
      type: Boolean,
      note: 'Mostrar os checks na tabela'
    },
    role: {
      type: String,
      required: false
    },
    elementos: {
      type: [Number, String],
      required: false
    },
    nomeAcao: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      rowsHeader: [{ text: 'Nome do Colaborador', icon: 'repeat' }, { text: 'Cargo', icon: 'repeat' }, { text: 'E-mail', icon: 'repeat' }, { text: 'Status' }],
      rows: this.colaboradores,
      selected: [],
      editar: JSON.parse(localStorage.getItem('optionEdit')),
      hoverIndex: -1,
      showButton: false,
      elementsPerPage: '05'
    }
  },
  methods: {
    changeElement(element) {
      this.$emit('change-element', element)
      this.elementsPerPage = element
    },
    downRow() {
      this.hoverIndex = -100
      this.showButton = false
    },
    hoverRow(index) {
      this.showButton = true
      this.hoverIndex = index
    },
    ordenaTable(ordem) {
    this.$emit('ordena', ordem)
    },
  },
  watch: {
    colaboradores() {
      this.rows = this.colaboradores
    }
  }
}
</script>

<style lang="sass">
.circle-status
  border-radius: 10px
  width: 9px
  height: 9px

.areamodal > .table-cadu
  border: none
  border-radius: 0px
  width: 100%
  padding: 0px
  padding-top: 16px

.areamodal > .table-cadu > .table > table
  width: 100%
</style>
